<template>
  <div>
    <v-card class="mb-5 rounded-lg elevation-2">
      <v-card-title class="py-4">
        <v-icon left color="primary" size="30">mdi-update</v-icon>
        <div><div class="text-h5 font-weight-medium">Khách hàng sale cập nhật mới nhất</div><div class="text-body-2 grey--text">Theo dõi khách hàng vừa được nhân viên sale chỉnh sửa</div></div>
      </v-card-title>
    </v-card>
    <v-card class="rounded-lg elevation-2">
      <v-card-title><v-row>
        <v-col cols="12" md="4"><v-text-field v-model="search" label="Tên hoặc số điện thoại" prepend-inner-icon="mdi-magnify" outlined dense clearable hide-details @keyup.enter="applyFilters" /></v-col>
        <v-col cols="12" md="3"><v-select v-model="saleId" :items="saleOptions" item-text="text" item-value="value" label="Sale cập nhật" prepend-inner-icon="mdi-account-tie" outlined dense clearable hide-details @change="applyFilters" /></v-col>
        <v-col cols="12" md="3"><v-text-field v-model="updatedDate" type="date" label="Ngày cập nhật" prepend-inner-icon="mdi-calendar" outlined dense clearable hide-details @change="applyFilters" /></v-col>
        <v-col cols="12" md="2"><v-btn block color="primary" outlined @click="applyFilters"><v-icon left>mdi-filter</v-icon>Lọc</v-btn></v-col>
      </v-row></v-card-title>
      <v-data-table :headers="headers" :items="customers" :loading="loading" :server-items-length="total" :options.sync="options" :footer-props="{ 'items-per-page-options': [10,20,50] }">
        <template v-slot:item.customer="{ item }"><div class="font-weight-medium">{{ item.name }}</div><div class="text-caption grey--text">{{ item.phone }}</div></template>
        <template v-slot:item.sale="{ item }"><v-chip small outlined color="indigo"><v-icon left small>mdi-account-tie</v-icon>{{ item.updated_by_name || item.sale_name || 'Không xác định' }}</v-chip></template>
        <template v-slot:item.updated_at="{ item }">{{ formatDate(item.updated_at) }}</template>
        <template v-slot:item.action="{ item }"><v-btn small text color="primary" @click="$router.push({ path: '/customer', query: { id: item.id } })">Mở khách hàng</v-btn></template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import customerModule from '@/api/customers'
const customerActions = customerModule.actions
export default {
  name: 'CustomerLatestUpdates',
  data: () => ({
    customers: [], total: 0, loading: false, search: '', saleId: null, updatedDate: '',
    saleOptions: [], options: { page: 1, itemsPerPage: 10 },
    headers: [
      { text: 'Khách hàng', value: 'customer', sortable: false }, { text: 'Địa chỉ', value: 'address', sortable: false },
      { text: 'Sale cập nhật', value: 'sale', sortable: false }, { text: 'Cập nhật lúc', value: 'updated_at', sortable: false },
      { text: '', value: 'action', sortable: false, align: 'right' }
    ]
  }),
  watch: { options: { deep: true, handler() { this.fetchCustomers() } } },
  mounted() { this.fetchSaleOptions(); this.fetchCustomers() },
  methods: {
    async fetchSaleOptions() {
      try {
        const response = await customerActions.getCustomers({ latest_updates: 1, page: 1, per_page: 1000 })
        const map = new Map()
        ;(response.data?.data || []).forEach(item => {
          const id = Number(item.updated_by_user_id || item.user_id)
          if (id) map.set(id, { value: id, text: item.updated_by_name || item.sale_name || `Sale #${id}` })
        })
        this.saleOptions = Array.from(map.values()).sort((a, b) => a.text.localeCompare(b.text, 'vi'))
      } catch (error) { this.$snackbar.error('Không thể tải danh sách sale') }
    },
    async fetchCustomers() {
      this.loading = true
      try {
        const response = await customerActions.getCustomers({ latest_updates: 1, search: this.search || undefined, updated_sale_id: this.saleId || undefined, updated_date: this.updatedDate || undefined, page: this.options.page, per_page: this.options.itemsPerPage })
        this.customers = response.data?.data || []; this.total = Number(response.data?.meta?.total || 0)
      } catch (error) { this.$snackbar.error('Không thể tải danh sách cập nhật') }
      finally { this.loading = false }
    },
    applyFilters() { this.options.page = 1; this.fetchCustomers() },
    formatDate(value) { return value ? new Date(value).toLocaleString('vi-VN') : '—' }
  }
}
</script>
